/** Replace :id in path with id passed. */
export const pathWithId = (path: string, id: number | string): string =>
    path.replace(':id', id.toString())
